// React core imports
import React, { useState, useRef, useEffect } from "react";

// HTTP client for API calls
import Axios from "axios";

// Redux dispatch hook
import { useDispatch, useSelector } from "react-redux";

// Custom utility functions
import selectCorrectUrls from "../../selectCorrectUrls";
import GA from "../functions/GA";

// UI components and libraries
import PuffLoader from "react-spinners/PuffLoader";
import { css } from "@emotion/react";

// Alert/Popup library
import Swal from "sweetalert2";

const AgentLogin = () => {
  // Redux dispatch hook
  const dispatch = useDispatch();

  // Message states
  const [message, setMessage] = useState("");
  const [isMessage, setIsMessage] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [showErrorMsg, setshowErrorMsg] = useState("");

  // Status flags
  const [failed, setFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Agent login states
  const [agentUsername, setAgentUserName] = useState("");
  const [agentPassword, setAgentPassword] = useState("");
  const [agentActionUrl, setAgentActionUrl] = useState("");
  const [isAgentDisabled, setAgentDisabled] = useState(true);
  const [isForgotPasswordAgent, setIsForgotPasswordAgent] = useState(false);
  const [forgotPasswordAgent, setForgotPasswordAgent] = useState("");

  // Customer login states
  const [customerUsername, setCustomerUsername] = useState("");
  const [isForgotPasswordCustomer, setIsForgotPasswordCustomer] =
    useState(false);
  const [forgotPasswordCustomer, setForgotPasswordCustomer] = useState("");

  // Form validation errors
  const [errors, setErrors] = useState({ username: false, password: false });

  // Location-specific flag (e.g., Texas)
  const [texas, setTexas] = useState(false);

  // Forgot password timers and flags
  const [forgotPasswordTimerSecondsAgent, setForgotPasswordTimerSecondsAgent] =
    useState(120);
  const [isForgotPasswordTimerAgent, setIsForgotPasswordTimerAgent] =
    useState(false);
  const [
    forgotPasswordTimerSecondsCustomer,
    setForgotPasswordTimerSecondsCustomer,
  ] = useState(120);
  const [isForgotPasswordTimerCustomer, setIsForgotPasswordTimerCustomer] =
    useState(false);

  // Confirm login message flag
  const [isconfirmLoginMessage, setIsConfirmLoginMessage] = useState(false);

  const showTexasAgentMessageReducer = useSelector(
    (state) => state.showTexasAgentMessageReducer
  );

  // Correct field names and IDs for accessibility or form control - Agent
  const [correctNamesAndIds, setCorrectNamesAndIds] = useState({
    username: "",
    password: "",
    nameUserId: "",
    namePassword: "",
  });

  // Correct field names and IDs - Customer
  const [correctNamesAndIdsCustomer, setCorrectNamesAndIdsCustomer] = useState({
    username: "",
    password: "",
    nameUserId: "",
    namePassword: "",
  });

  // Helper function to reset the above "correct names and ids" state objects
  const resetState = (setStateFn) => {
    setStateFn({
      username: "",
      password: "",
      nameUserId: "",
      namePassword: "",
    });
  };

  // CSS override for loader component
  const override = css`
    display: flex;
    margin: auto;
    color: white;
    margin-top: -7px;
  `;

  // HTML message state (can hold formatted HTML)
  const [weather_message_html, set_weather_message_html] =
    useState(`<p>Hello there</p>`);

  const isTabletOrDesktop = () => window.innerWidth >= 768; // adjust breakpoint as needed
  const [isLargeScreen, setIsLargeScreen] = useState(isTabletOrDesktop());

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(isTabletOrDesktop());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Reference to DOM element, used for focus or other direct manipulations
  const [canContinue, setCanContinue] = useState(false);

  const ref = useRef(null);

  const onScroll = () => {
    const el = ref.current;
    if (!el) return;
    // only enforce scroll check on larger screens
    if (isLargeScreen) {
      setCanContinue(el.scrollHeight - el.scrollTop - el.clientHeight < 5);
    }
  };

  const checkDisabledButtonAgent = () => {
    if (isAgentDisabled) {
      return "home-page-button-off";
    } else return "home-page-button";
  };

  const [config, setConfig] = useState({
    headers: {
      "Content-Type": "text/html",
    },
    responseType: "text",
  });

  const showSuccess = (msg) => {
    Swal.fire({
      icon: "success",
      title: "Success",
      width: "auto",
      text: msg,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const showError = (msg) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: msg,
    });
  };

  const getInputClass = (value, error) => {
    if (error) return "form-control border-danger";
    if (value.trim() !== "") {
      return failed
        ? "form-control border-danger"
        : "form-control border-success";
    }
    return "form-control";
  };

  //login for the agent portal
  const agentValidPost = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const newErrors = {
      username: agentUsername.trim() === "",
      password: agentPassword.trim() === "",
    };
    setErrors(newErrors);

    if (!newErrors.username && !newErrors.password) {
      let url = `${
        selectCorrectUrls().insuredPortal
      }/uaicins/agent/login/validate?tbxUserID=${agentUsername}&tbxPassword=${encodeURIComponent(
        agentPassword
      )}`;

      let urlWeather =
        "https://www.uaig.net/uaichome/static/msgs/fl_message.html";

      Axios.get(url, config)
        .then((response) => {
          setAgentActionUrl(response.data.url);
          // https://fl.uaig.net/agents/ndmacro/cmn_Login.mac/CheckLogin
          if (
            response.data.url ===
              `${
                selectCorrectUrls().florida
              }/agents/ndmacro/cmn_Login.mac/CheckLogin` ||
            response.data.url ===
              `${
                selectCorrectUrls().georgia
              }/agents/ndmacro/cmn_Login.mac/CheckLogin`
          ) {
            setTexas(false);
            setCorrectNamesAndIds({
              id: "tbxUserID",
              password: "tbxPassword",
              nameUserId: "tbxUserID",
              namePassword: "tbxPassword",
            });

            urlWeather =
              "https://www.uaig.net/uaichome/static/msgs/fl_message.html";
          } else if (
            response.data.url ===
            `${selectCorrectUrls().texas}/agents/cgi-dta/ilogin.mac/CheckLogin`
          ) {
            setTexas(true);
            setCorrectNamesAndIds({
              id: "UserID",
              nameUserId: "UserID",
              password: "Password",
              namePassword: "Password",
            });

            urlWeather =
              // "https://www.uaig.net/uaichome/static/msgs/tx_message.html";
              "https://quote7.uaig.net/uaicins/agent/login/txmsg";
            // "https://tx.uaig.net/agents/cgi-dta/TX_msg.mac/main";
          }

          Axios.post(urlWeather)
            .then((response_weather) => {
              console.log("response_weather", response_weather.data);
              setIsLoading(false);
              set_weather_message_html(response_weather.data);

              console.log("response.data.status", response.data.status);

              if (response_weather.data !== ".") {
                dispatch({
                  type: "SET_TX_AGENT_MESSAGE",
                  payload: response_weather.data
                    .split("<br><br>")[1]
                    .replace("<br>", "")
                    .trim(),
                });
              }
              // console.log("weather_message_html", weather_message_html);
              if (response.data.status === 1) {
                if (response_weather.data !== ".") {
                  setIsConfirmLoginMessage(true);
                  dispatch({
                    type: "SET_TX_AGENT_DISPLAY",
                    payload: true,
                  });
                } else {
                  GA(
                    "AGENT_LOGIN_SUCCESSFUL",
                    `${agentUsername} - Succesfully logged into Agent Portal`
                  );

                  setIsLoading(false);
                  setIsMessage(true);
                  setFailed(false);
                  setMessage(response.data.msg);
                  console.log("INSIDE OF ELSE response.data.status");
                  document.getElementById("mainFormAgent").submit();
                  // document.getElementById("mainFormAgent").submit();
                  // {
                  //   showModal && showSuccess(response.data.msg);
                  //   setshowErrorMsg(response.data?.msg);
                  // }
                  // setTimeout(() => {
                  //   document.getElementById("mainFormAgent").submit();
                  // }, 2000);
                }
              } else {
                e.preventDefault();

                GA(
                  "AGENT_LOGIN_FAILED",
                  `${agentUsername} - Agent failed to logged into Agent Portal`
                );

                setIsErrorMessage(true);
                setMessage(response.data.msg);
                setAgentPassword("");
                setIsLoading(false);
                setFailed(true);
                {
                  isMessage && showModal && showSuccess(response.data.msg);
                  setshowErrorMsg(response.data?.msg);
                }
              }
            })
            .catch((e_weather) => {
              setIsLoading(false);

              if (response.data.status === 1) {
                setIsMessage(true);
                // setMessage(response.data.msg);
                setFailed(true);
                {
                  isMessage && showModal && showSuccess(response.data.msg);
                  setshowErrorMsg(response.data?.msg);
                }
                resetState(setCorrectNamesAndIds);

                setTimeout(() => {
                  document.getElementById("mainFormAgent").submit();
                }, 1000);
              } else {
                e.preventDefault();

                // setIsErrorMessage(true);
                // setMessage(response.data.msg);
                {
                  isMessage && showModal && showSuccess(response.data.msg);
                  setshowErrorMsg(response.data?.msg);
                }
              }
            });
        })
        .catch((e) => {
          setIsLoading(false);

          //set a custom error message in the div  : System Failure: Please try after some time.

          GA(
            "AGENT_SYSTEM_FAILURE",
            `${customerUsername} -  System failure while trying to log into the Aent Portatl`
          );

          // setIsErrorMessage(true);
          setMessage("System Failure: Please try after some time.");

          // console.log(e);
        });
    }
  };

  const sendForgotPasswordEmail = (e, where) => {
    e.preventDefault();
    setIsLoading(true);

    setIsForgotPasswordAgent(false);
    setIsForgotPasswordCustomer(false);

    //this is a test url, once we have the correct service we can send emails to the email that the user typed

    let url = "";

    if (where === "agent") {
      url = `${
        selectCorrectUrls().insuredPortal
      }/uaicins/agent/forgotpassword/index?agentid=${forgotPasswordAgent}`;

      Axios.get(url, config)
        .then((response) => {
          setIsLoading(false);

          if (response.data.status === 1 || response.data.status === "1") {
            setIsMessage(true);
            setIsLoading(false);
            resetState(setCorrectNamesAndIds);
            setForgotPasswordAgent("");
            setMessage(response.data.msg);
            GA(
              "FORGOT_PASSWORD_AGENT",
              `${forgotPasswordAgent} - Successfully requested to change password`
            );

            setForgotPasswordTimerSecondsAgent(120);
            setIsForgotPasswordTimerAgent(true);
          } else if (response.data.status == 0) {
            GA(
              "FORGOT_PASSWORD_AGENT_FAILED",
              `${forgotPasswordAgent} - Failed to request to change password`
            );
            setForgotPasswordAgent("");
            setIsLoading(false);
            setFailed(true);
            setIsErrorMessage(true);
            setMessage(response.data.msg);
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setFailed(true);
          setForgotPasswordAgent("");
          console.log(e);
          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);
          setIsErrorMessage(true);
          setMessage("Something went wrong, try again later.");
        });
    } else if (where === "customer") {
      url = `${
        selectCorrectUrls().insuredPortal
      }/insurednew/insured/pms/fp?email-id=${forgotPasswordCustomer}`;

      Axios.get(url)
        .then((response) => {
          setIsLoading(true);

          // console.log(response);

          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);

          if (response.data.status == 1 || response.data.status == "1") {
            resetState(setCorrectNamesAndIdsCustomer);
            setIsMessage(true);
            setForgotPasswordCustomer("");

            setIsLoading(false);
            setFailed(false);
            setMessage(response.data.displaymsg);
            // setMessage(
            //   "If a valid email is found we would be sending instructions to reset password in the email."
            // );
            GA(
              "FORGOT_PASSWORD_CUSTOMER",
              `${forgotPasswordCustomer} - Successfully requested to change password`
            );

            setForgotPasswordTimerSecondsAgent(120);
            setIsForgotPasswordTimerAgent(true);
          } else if (
            response.data.status === 0 ||
            response.data.status === "0"
          ) {
            GA(
              "FORGOT_PASSWORD_CUSTOMER_FAILED",
              `${forgotPasswordCustomer} - Failed to request to change password`
            );

            setIsMessage(true);
            setIsLoading(false);
            setMessage(response.data.displaymsg);
            setForgotPasswordTimerSecondsCustomer(120);
            setIsForgotPasswordTimerCustomer(true);
          }
        })
        .catch((e) => {
          setIsLoading(false);

          console.log(e);
          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);
          setIsErrorMessage(true);
          setMessage("Something went wrong, try again later.");
        });
    }
  };

  const confirmLoginMessage = () => {
    return (
      <div
        style={{
          padding: responsiveStatus ? ".5em" : "",
          width: responsiveStatus ? "100%" : "",
          marginBottom: responsiveStatus ? "1.5em" : "",
        }}
      >
        <div
          className={
            isconfirmLoginMessage
              ? "forgot-password-background-on"
              : "forgot-password-background-off"
          }
        ></div>
        <div
          className={
            isconfirmLoginMessage
              ? "confirm-login-message-component-open"
              : "confirm-login-message-component-closed"
          }
          style={{ position: "relative" }}
        >
          <div>
            <center>
              <h3>
                Please Read <span className="MOBILE-ONLY"> / Scroll</span>{" "}
                Before Continuing
              </h3>
            </center>
            <hr />
            <div
              ref={ref}
              className="weather-message"
              dangerouslySetInnerHTML={{ __html: weather_message_html }}
              style={{ overflowY: "scroll", height: 150, marginBottom: 16 }}
              onScroll={onScroll}
            />
            <hr />
            <div className="continue-button-confirm-login">
              <button
                // disabled={!canContinue}
                disabled={isLargeScreen && !canContinue}
                style={{
                  backgroundColor: " rgb(14, 114, 214)",
                  color: "white",
                  border: "none",
                  padding: "4px 6px",
                }}
                onClick={() => {
                  document.getElementById("mainFormAgent").submit();
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (
      weather_message_html !== "<p>Hello there</p>" &&
      weather_message_html !== "." &&
      isconfirmLoginMessage
    ) {
      dispatch({
        type: "SET_TX_AGENT_DISPLAY",
        payload: true,
      });
    } else {
      if (!showTexasAgentMessageReducer) {
        dispatch({
          type: "SET_TX_AGENT_DISPLAY",
          payload: false,
        });
      }
    }
  }, [weather_message_html]);
  return (
    <>
      <form
        action={agentActionUrl}
        name="mainFormAgent"
        id="mainFormAgent"
        method="POST"
        style={{
          display: showTexasAgentMessageReducer ? "none" : "block",
        }}
      >
        <>
          {message !== "" ? (
            <p
              style={{
                color:
                  failed && message !== "verification mail sent"
                    ? "red"
                    : "green",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {message}
            </p>
          ) : (
            ""
          )}

          <>
            {" "}
            <div className="mb-3">
              <input
                style={{
                  fontSize: "11px",
                  color: "#A09999",
                  padding: "17px 15px",
                }}
                type="text"
                value={agentUsername}
                name={correctNamesAndIds.nameUserId}
                onChange={(e) => {
                  setAgentUserName(e.target.value);
                }}
                className={getInputClass(agentUsername, errors.username)}
                placeholder="Username"
              />
            </div>
            <div className="mb-3">
              <input
                style={{
                  fontSize: "11px",
                  color: "#A09999",
                  padding: "17px 15px",
                }}
                type="password"
                value={agentPassword}
                name={correctNamesAndIds.namePassword}
                onChange={(e) => {
                  setAgentPassword(e.target.value);
                }}
                className={getInputClass(agentPassword, errors.password)}
                placeholder="Password"
              />
              {/* <span className="text-danger">{showErrorMsg}</span> */}
            </div>
            <button
              style={{
                width: "100%",
                backgroundColor: "#0E72D6",
              }}
              onClick={(e) => {
                agentValidPost(e);
                GA(
                  "Log_In ",
                  "User clicked on the agents login button inside pop up"
                );
              }}
              className={checkDisabledButtonAgent(isAgentDisabled)}
              type="submit"
              disabled={agentPassword === "" || agentUsername === ""}
            >
              {isLoading ? (
                <div>
                  <PuffLoader color={"white"} css={override} size={30} />
                </div>
              ) : (
                "Login"
              )}
            </button>
            <div className="text-center mt-3" style={{ fontSize: "14px" }}>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsForgotPasswordAgent(true);
                }}
                className="text-primary text-decoration-none"
              >
                Reset Password
              </span>
            </div>
          </>
        </>
      </form>

      {!responsiveStatus && isForgotPasswordAgent && (
        <>
          <div
            className="modal show fade d-block second-modal"
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className="modal-content"
                style={{ width: `${responsiveStatus ? "auto" : "auto"}` }}
              >
                <div className="modal-header">
                  <h5 className="modal-title">Forgot your password?</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setIsForgotPasswordAgent(false);
                      dispatch({
                        type: "SET_LOGIN_PAGE_TO_DISPLAY",
                        payload: "AGENT",
                      });
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  <div
                    className="modal-dialog modal-sm modal-dialog-centered"
                    style={{ margin: "0px" }}
                    role="document"
                  >
                    <div
                      className="modal-content d-flex flex-column p-1"
                      style={{ border: "none" }}
                    >
                      <p>Enter your Username:</p>
                      <form
                        style={{ width: "100%" }}
                        onSubmit={(e) => sendForgotPasswordEmail(e, "agent")}
                      >
                        <input
                          type="text"
                          placeholder="Username"
                          value={forgotPasswordAgent}
                          onChange={(e) => {
                            setForgotPasswordAgent(e.target.value);
                          }}
                          className="form-control mb-3"
                          required
                          autoFocus
                        />
                        <button
                          style={{
                            width: "100%",
                            backgroundColor: "#0E72D6",
                            border: "1px solid blue",
                            color: "#FFF",
                            padding: "8px",
                          }}
                          disabled={isForgotPasswordTimerAgent}
                          type="submit"
                        >
                          {/* {isForgotPasswordTimerAgent
                            ? forgotPasswordTimerSecondsAgent
                            : "Submit"}
                            {} */}
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
      {responsiveStatus && isForgotPasswordAgent && (
        <>
          <div
            className="modal show fade d-block second-modal"
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="modal-content" style={{ width: `70%` }}>
                <div className="modal-header">
                  <h5 className="modal-title">Forgot your password?</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setIsForgotPasswordAgent(false);
                      setShowModal(true);
                      dispatch({
                        type: "SET_LOGIN_PAGE_TO_DISPLAY",
                        payload: "AGENT",
                      });
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  <div
                    className="modal-dialog modal-sm modal-dialog-centered"
                    style={{ margin: "0px" }}
                    role="document"
                  >
                    <div
                      className="modal-content d-flex flex-column p-1"
                      style={{ border: "none" }}
                    >
                      <p>Enter your Username:</p>
                      <form
                        style={{ width: "100%" }}
                        onSubmit={(e) => sendForgotPasswordEmail(e, "agent")}
                      >
                        <input
                          type="text"
                          placeholder="Username"
                          value={forgotPasswordAgent}
                          onChange={(e) => {
                            setForgotPasswordAgent(e.target.value);
                          }}
                          className="form-control mb-3"
                          required
                          autoFocus
                        />
                        <button
                          style={{
                            width: "100%",
                            backgroundColor: "#0E72D6",
                            border: "1px solid blue",
                            color: "#FFF",
                            padding: "8px",
                          }}
                          disabled={isForgotPasswordTimerAgent}
                          type="submit"
                        >
                          {/* {isForgotPasswordTimerAgent
                            ? forgotPasswordTimerSecondsAgent
                            : "Submit"} */}
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};

export default AgentLogin;
